/**
 * Which of a story's covers `<Cover>` draws: the approved illustration
 * (`cover_image_url` / `cover_image_thumb_url`), else the generated
 * `cover_svg`, else the striped placeholder. Pure, so the whole fallback
 * chain is testable without a DOM.
 */

/** "thumb" (400px) for grids and small tiles, "full" (1024px) where the
 *  cover is shown large — the story page, the player. */
export type CoverImageSize = "thumb" | "full";

/** The image URL to load for `size`, or `null` when the story has no
 *  approved illustration. The backend sets both URLs or neither; if only
 *  one ever came through, it is still better than the SVG. */
export function coverImageSrc(
  imageUrl: string | null | undefined,
  thumbUrl: string | null | undefined,
  size: CoverImageSize,
): string | null {
  const src = size === "full" ? imageUrl || thumbUrl : thumbUrl || imageUrl;
  return src || null;
}

export type CoverKind = "image" | "svg" | "placeholder";

/** `failedSrc` is the last image URL that fired `onError` — that one is
 *  skipped (a broken image must never leave an empty frame), but a new URL
 *  gets its chance again. */
export function coverKind(
  imageSrc: string | null,
  failedSrc: string | null,
  hasSvg: boolean,
): CoverKind {
  if (imageSrc && imageSrc !== failedSrc) return "image";
  return hasSvg ? "svg" : "placeholder";
}
